/* External */
import { useMemo } from 'react';
import { useIntl } from 'react-intl';

/* Utils */
import {
  getFormattedDuration,
  useFullEpisodeName,
  getRating,
  isEpisode,
  isMovie,
  isShow,
  joinArrayWithSeparator,
  joinArrayWithSpace,
  isSports,
} from '../../utils/metaDataUtils';

export function useFeaturedCarouselSubtitle(content, isLive = false) {
  const { formatMessage } = useIntl();
  const fullEpisodeName = useFullEpisodeName(content);

  return useMemo(() => {
    if (isEpisode(content)) {
      return joinArrayWithSpace([
        getRating(content),
        fullEpisodeName,
      ]);
    }

    return joinArrayWithSpace([
      getRating(content),
      joinArrayWithSeparator([
        isShow(content) && formatMessage({ id: 'common.serie' }),
        !isLive && (isMovie(content) || isSports(content)) && content?.releaseYear,
        joinArrayWithSeparator((content?.genres ?? [])?.slice(0, 3)),
        !isLive && (isMovie(content) || isSports(content)) && getFormattedDuration(content),
      ]),
    ]);
  }, [content, formatMessage, fullEpisodeName, isLive]);
}
